import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PostbackPage } from './PostbackPage';
import { actions } from './PostbackPage.actions';
import { getCurrencies } from './PostbackPage.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    currencies: getCurrencies
});

function mapStateToProps(state) {
    return {
        ...mapStateToPropsSelectors(state),
        errors: state.postbacks.errors,
        loadingSave: state.postbacks.loadingSave,
        saveSuccess: state.postbacks.saveSuccess,
        user: state.user
    };
}

function mapDispatchToProps() {
    return {
        onSave: actions.onSave,
        clearErrors: actions.clearErrors
    };
}

function WithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
        <PostbackPage
            {...props}
            location={location}
            navigate={navigate}
            params={params}
        />
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouterProps);
